import { render, staticRenderFns } from "./cardCheck.vue?vue&type=template&id=04620f97&scoped=true&"
import script from "./cardCheck.vue?vue&type=script&lang=js&"
export * from "./cardCheck.vue?vue&type=script&lang=js&"
import style0 from "./cardCheck.vue?vue&type=style&index=0&id=04620f97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04620f97",
  null
  
)

export default component.exports